import utils from 'util/utils';
import {
  getSignedInUser,
  sendCodeRequest,
  sendValidateDeviceRequest,
  sendValidateRemoteRequest
} from './functions';
import feathers from 'util/client';
import { SELECT_ROTATION_PARTICIPANT } from '../large-video/actionTypes';
import { isStageFilmstripAvailable } from '../filmstrip/functions';
import isEmpty from 'lodash/isEmpty';

export const LOGIN = 'LOGIN';
export const SET_LOADING = 'SET_LOADING';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const LOGOUT = 'LOGOUT';

/**
 * Action used to set the jaas customer details in store.
 *
 * @param {Object} details - The customer details object.
 * @returns {Object}
 */
export function setUserDetails(details) {
  return {
    type: SET_USER_DETAILS,
    payload: details
  };
}

export function logout() {
  return {
    type: LOGOUT
  };
}
export function reAuthenticate(reconnect = false) {
  return async function (dispatch) {
    try {
      if (!reconnect) {
        dispatch({ type: SET_LOADING, payload: true });
      } else {
        dispatch({ type: SET_AUTHENTICATED, payload: false });
      }

      await feathers.reAuthenticate();
      // console.log(result);
    } catch (err) {
      console.error(err);
      dispatch({ type: SET_LOADING, payload: false });
      // dispatch(setUserDetails(null));
    }
  };
}

export function sendRemoteCode(email, callback) {
  return async function () {
    try {
      const result = await sendCodeRequest({ email });
      if (result) callback(true, result.user);
      else callback(false);
    } catch (err) {
      console.error(err);
      callback(false, err);
    }
  };
}

export function validateRemoteCode(email, code, callback) {
  return async function () {
    try {
      const result = await sendValidateRemoteRequest({
        email,
        code: parseInt(code)
      });
      if (result) {
        // dispatch(fetchUserDevice(result.user?._id));
        callback(true, result.user);
      } else callback(false);
    } catch (err) {
      console.error(err);
      callback(false, err);
    }
  };
}
export function validateDeviceCode(code, callback) {
  return async function () {
    try {
      const result = await sendValidateDeviceRequest({ code });
      if (result) {
        // dispatch(fetchUserDevice(result.user?._id));
        callback(true, result.user);
      } else callback(false);
    } catch (err) {
      console.error(err);
      callback(false, err);
    }
  };
}
/**
 * Sends a request to the server to update the device data
 * @deprecated - server is no longer listening for this event
 */
export function updateDevice(data) {
  // eslint-disable-next-line no-unused-vars
  return function (dispatch, getState) {
    feathers.io.emit('state', 'device', data, {}, (e) => {
      if (e) {
        console.log('could not update device state', e);
        return;
      }
    });
  };
}

const waitFor = (callback, handler, defaultInterval = 1000) => {
  if (!handler()) {
    setTimeout(() => {
      waitFor(callback, handler);
    }, defaultInterval);
  } else {
    callback();
  }
};

export function joinRotation(id) {
  // eslint-disable-next-line no-unused-vars
  return async function (dispatch, getState) {
    try {
      const authenticated = () => {
        return window.isAuthenticated;
      };

      waitFor(() => {
        const { user } = getState()['features/login'];
        if (utils.isRemoteLogin(user)) return;
        dispatch({
          type: SELECT_ROTATION_PARTICIPANT,
          participantId: null,
          onStage: isStageFilmstripAvailable(getState(), 1)
        });
        console.log('join-rotation', id);
        const body = { group: id };
        feathers
          .service('cluster')
          .join(body)
          .then(() => {
            // console.log(response);
          })
          .catch((error) => {
            console.log(error);
            if (error.code === 406) {
              dispatch(joinRotation(id));
            }
          });
      }, authenticated);
    } catch (e) {
      console.log(e);
    }
  };
}
export function leaveRotation() {
  // eslint-disable-next-line no-unused-vars
  return async function (dispatch, getState) {
    try {
      const authenticated = () => {
        return window.isAuthenticated;
      };

      waitFor(() => {
        const { user } = getState()['features/login'];
        const { room } = getState()['features/base/settings'];
        if (utils.isRemoteLogin(user)) return;
        dispatch({
          type: SELECT_ROTATION_PARTICIPANT,
          participantId: null,
          onStage: isStageFilmstripAvailable(getState(), 1)
        });
        console.log('leave-rotation', room);
        const body = { group: room };
        feathers
          .service('cluster')
          .leave(body)
          .then(() => {
            // console.log(response);
          })
          .catch((error) => {
            console.log(error);
            if (error.code === 406) {
              dispatch(leaveRotation());
            }
          });
      }, authenticated);
    } catch (e) {
      console.log(e);
    }
  };
}
export function sendPairACK(id) {
  // eslint-disable-next-line no-unused-vars
  return async function (dispatch, getState) {
    try {
      const authenticated = () => {
        return window.isAuthenticated;
      };

      waitFor(() => {
        const body = { group: id, status: 'paired' };
        feathers
          .service('cluster')
          .ack(body)
          .then((response) => {
            console.log('ACK', response);
          })
          .catch((error) => {
            console.log(error);
            if (error.code === 406) {
              dispatch(sendPairACK(id));
            }
          });
      }, authenticated);
    } catch (e) {
      console.log(e);
    }
  };
}
export function fetchUserDevice(id, callback) {
  return async function (dispatch, getState) {
    try {
      const authenticated = window.isAuthenticated;
      if (authenticated) {
        const result = await feathers.service('user').get(id, {
          query: {
            $populate: [
              'device',
              {
                path: 'device',
                populate: [
                  { path: 'country' },
                  { path: 'city' },
                  { path: 'timezone' },
                  { path: 'business' },
                  {
                    path: 'groups',
                    populate: {
                      path: '_id',
                      model: 'group'
                    }
                  }
                ]
              }
            ]
          }
        });
        if (result) {
          const user = getSignedInUser(getState());
          dispatch(setUserDetails(result)).then(() => {
            if (callback) {
              if (user && user.device) {
                const {
                  showJoinLeaveAudioButton,
                  showMicrophoneButton,
                  speakerMode,
                  microphoneMode
                } = user.device.options;
                const options = result.device?.options;
                if (
                  showJoinLeaveAudioButton !==
                    options.showJoinLeaveAudioButton ||
                  showMicrophoneButton !== options.showMicrophoneButton ||
                  speakerMode !== options.speakerMode ||
                  microphoneMode !== options.microphoneMode
                )
                  callback(true, result);
                else callback(false, result);
              } else callback(false, result);
            }
          });
        }
      }
    } catch (err) {
      console.error(err);
      // if (callback) callback(false, err?.message);
    }
  };
}

export function fetchUserInfo(id) {
  return async function (dispatch, getState) {
    const loading = getState()['features/login'].loading;
    const authenticated = window.isAuthenticated;
    if (id !== null && id !== 'off' && !loading && authenticated) {
      try {
        const result = await feathers.service('user').get(id, {
          query: {
            $populate: [
              'device',
              {
                path: 'device',
                populate: ['country', 'city', 'timezone']
              }
            ]
          }
        });
        if (result) {
          dispatch({
            type: SET_USER_PROFILE,
            payload: {
              id,
              data: result
            }
          });
          return result;
        }
      } catch (err) {
        console.error(err);
      }
    }
  };
}

export function sendStatistics(stats) {
  // eslint-disable-next-line no-unused-vars
  return async function (dispatch, getState) {
    try {
      const authenticated = window.isAuthenticated;
      if (authenticated) {
        const { user } = getState()['features/login'];
        const { room } = getState()['features/base/settings'];
        const { userSleepMode } = getState()['features/settings'];
        const group = user.device?.groups?.find((ob) => ob._id._id === room);
        const deviceName = !isEmpty(user.device?.name)
          ? user.device?.name
          : !isEmpty(user.device?.nickname)
          ? user.device.nickname
          : user.firstName + ' ' + user.lastName + "'s Device";

        feathers
          .service('statistic')
          .collect({
            ...stats,
            device: user.device?._id,
            deviceName,
            type: user.device?.type,
            sleeping: userSleepMode,
            group: room,
            groupName: group?._id?.name,
            uuid: utils.fetchLocalUUID()
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (e) {
      console.log(e);
    }
  };
}
